/* Eleanor Cheltenham — cart drawer: open/close + AJAX Cart API sync. */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');
  var openTriggers = document.querySelectorAll('[data-cart-open]');
  var closeTriggers = document.querySelectorAll('[data-cart-close]');
  var itemsRoot = document.querySelector('[data-cart-items]');
  var subtotalEl = document.querySelector('[data-cart-subtotal]');
  var footer = document.querySelector('[data-cart-footer]');
  var countEls = document.querySelectorAll('[data-cart-count]');
  var recommendationRoot = document.querySelector('[data-cart-recommendations]');
  var recommendationCatalogEl = document.querySelector('[data-cart-recommendation-catalog]');
  var recommendationCatalog = { products: [] };
  try { if (recommendationCatalogEl) recommendationCatalog = JSON.parse(recommendationCatalogEl.textContent); } catch (e) { recommendationCatalog = { products: [] }; }

  if (!drawer) return;

  var returnFocus = null;
  var isUpdating = false;
  var refreshPromise = null;
  var refreshVersion = 0;

  function focusableElements(container) {
    return Array.prototype.slice.call(container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'));
  }

  function open() {
    returnFocus = document.activeElement;
    drawer.removeAttribute('inert');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.setAttribute('data-open', 'true');
    if (overlay) overlay.setAttribute('data-open', 'true');
    openTriggers.forEach(function (button) { button.setAttribute('aria-expanded', 'true'); });
    document.body.style.overflow = 'hidden';
    var closeButton = drawer.querySelector('[data-cart-close]');
    if (closeButton) closeButton.focus();
    document.dispatchEvent(new CustomEvent('cart:view'));
    window.EleanorAnalytics && EleanorAnalytics.track('view_cart', {});
  }
  function close() {
    drawer.setAttribute('data-open', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    if (overlay) overlay.setAttribute('data-open', 'false');
    openTriggers.forEach(function (button) { button.setAttribute('aria-expanded', 'false'); });
    document.body.style.overflow = '';
    if (returnFocus && returnFocus.focus) returnFocus.focus();
  }

  openTriggers.forEach(function (btn) { btn.addEventListener('click', open); });
  closeTriggers.forEach(function (btn) { btn.addEventListener('click', close); });
  if (overlay) overlay.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (drawer.getAttribute('data-open') !== 'true') return;
    if (e.key === 'Escape') {
      close();
      return;
    }
    if (e.key === 'Tab') {
      var focusable = focusableElements(drawer);
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  function openAfterRefresh() {
    var pending = refreshPromise;
    if (pending) {
      pending.then(open);
    } else {
      open();
    }
  }
  document.addEventListener('cart:open', openAfterRefresh);

  function formatMoney(cents) { return '£' + (cents / 100).toFixed(2); }

  function escapeRec(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function recommendationChoices(product, colour) {
    var key = String(colour || '').split(' / ')[0].trim().toLowerCase();
    return product.pairings[key] || product.pairings.__all__ || [];
  }

  function offerChoices(product, colour) {
    var c = String(colour || '').split(' / ')[0].trim().toLowerCase();
    var colours = {'brown':'Wine Red','beige':'Pink','dark brown':'Wine Red','army green':'Green','green':'Green','black':'Black','coffee':'Wine Red','burgundy':'Wine Red','light brown':'Pink','khaki':'Green','chocolate':'Wine Red'};
    var existing = recommendationChoices(product, colour).find(function (pair) { return pair[0] === 'kiss-lock-coin-purse'; });
    return (product.curated || []).map(function (handle) {
      var selected = handle === 'kiss-lock-coin-purse' ? (existing ? existing[1] : colours[c]) : handle === 'the-iris-initial-necklace' ? '' : 'Gold';
      return [handle, selected || ''];
    });
  }

  function renderRecommendations(cart) {
    if (!recommendationRoot) return;
    var item = cart && cart.items && (cart.items.find(function (line) { var source = recommendationCatalog.products.find(function (p) { return String(p.id) === String(line.product_id); }); return source && source.curated && source.curated.length; }) || cart.items[0]);
    if (!item) { recommendationRoot.innerHTML = ''; return; }
    var product = recommendationCatalog.products.find(function (p) { return String(p.id) === String(item.product_id); });
    if (!product) { recommendationRoot.innerHTML = ''; return; }
    var cartProductIds = (cart.items || []).map(function (cartItem) { return String(cartItem.product_id); });
    function renderCards(choices, offerEligible) {
      return choices.map(function (choice) {
      var target = recommendationCatalog.products.find(function (p) {
        return p.handle === choice[0] && cartProductIds.indexOf(String(p.id)) === -1;
      });
      if (!target || !target.recommendable) return '';
      // Never replace a colour match with an unintended available variant.
      var colourNeeded = String(choice[1] || '').trim().toLowerCase();
      var targetVariant = colourNeeded ? target.variants.find(function (v) { return v.colour === colourNeeded && v.available; }) : target.variants.find(function (v) { return v.available; });
      if (!targetVariant) return '';
      return '<article class="cart-recommendation" data-cross-sell-item data-offer-eligible="' + offerEligible + '" data-product-id="' + target.id + '">' +
        '<a class="cart-recommendation__media" href="' + target.url + '?variant=' + targetVariant.id + '">' +
          '<img src="' + targetVariant.image + '" alt="' + escapeRec(target.title + ' in ' + targetVariant.title) + '" loading="lazy" width="500" height="625">' +
        '</a>' +
        '<div class="cart-recommendation__content">' +
          '<a class="cart-recommendation__details" href="' + target.url + '?variant=' + targetVariant.id + '">' +
            '<p class="cart-recommendation__title">' + escapeRec(target.title) + '</p>' +
            '<p class="cart-recommendation__variant">Match: ' + escapeRec(targetVariant.title) + '</p>' +
          '</a>' +
          '<div class="cart-recommendation__bottom">' +
            '<p class="cart-recommendation__price">£' + (targetVariant.price / 100).toFixed(2) + '</p>' +
            '<button type="button" class="cart-recommendation__add" data-cart-recommendation-add data-variant-id="' + targetVariant.id + '" data-product-id="' + target.id + '">Add match</button>' +
          '</div>' +
        '</div>' +
      '</article>';
      }).filter(Boolean).join('');
    }
    var offerCards = renderCards(offerChoices(product, item.variant_title), true);
    var editorial = recommendationChoices(product, item.variant_title).filter(function (pair) { return (product.curated || []).indexOf(pair[0]) === -1; });
    var editorialCards = renderCards(editorial, false);
    recommendationRoot.innerHTML = (offerCards ? '<section aria-label="Complete the Look"><p class="cart-recommendations__title">Complete the Look</p><div class="cart-recommendations__list">' + offerCards + '</div></section>' : '') + (editorialCards ? '<section aria-label="Eleanor Pairings"><p class="cart-recommendations__title">Eleanor Pairings</p><div class="cart-recommendations__list">' + editorialCards + '</div></section>' : '');
  }

  function addRecommendation(variantId, productId, button) {
    if (!variantId || isUpdating) return;
    isUpdating = true;
    var originalLabel = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding…';
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    }).then(function (res) {
      if (!res.ok) throw new Error('recommendation_add_failed');
      return res.json();
    }).then(function (item) {
      window.EleanorAnalytics && EleanorAnalytics.track('cart_cross_sell_add', {
        productId: productId,
        variantId: item.variant_id,
        quantity: item.quantity
      });
      return refresh();
    }).catch(function () {
      window.location.href = '/cart/add?id=' + encodeURIComponent(variantId) + '&quantity=1';
    }).finally(function () {
      isUpdating = false;
      if (button) {
        button.disabled = false;
        button.textContent = originalLabel || 'Add match';
      }
    });
  }

  if (recommendationRoot) {
    recommendationRoot.addEventListener('click', function (event) {
      var button = event.target.closest('[data-cart-recommendation-add]');
      if (!button) return;
      event.preventDefault();
      addRecommendation(
        button.getAttribute('data-variant-id'),
        button.getAttribute('data-product-id'),
        button
      );
    });
  }

  function render(cart) {
    countEls.forEach(function (el) { el.textContent = cart.item_count; el.setAttribute('data-count', cart.item_count); });
    openTriggers.forEach(function (button) {
      button.setAttribute('aria-label', 'Open bag, ' + cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's'));
    });
    renderRecommendations(cart);
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (footer) footer.hidden = cart.item_count === 0;
    if (!itemsRoot) return;

    if (cart.item_count === 0) {
      var continueUrl = itemsRoot.getAttribute('data-continue-shopping-url') || '/collections/all';
      itemsRoot.innerHTML = '<div class="cart-drawer__empty"><p>Your bag is empty.</p><a href="' + continueUrl + '" class="btn btn--secondary mt-3">Continue Shopping</a></div>';
      return;
    }

    itemsRoot.innerHTML = cart.items.map(function (item) {
      return '' +
        '<div class="cart-line" data-cart-line-key="' + item.key + '">' +
          '<div class="cart-line__media"><img src="' + item.image + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy" width="160" height="200"></div>' +
          '<div class="cart-line__body">' +
            '<p class="cart-line__title">' + escapeHtml(item.product_title) + '</p>' +
            (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="cart-line__variant">' + escapeHtml(item.variant_title) + '</p>' : '') +
            '<div class="cart-line__row">' +
              '<div class="qty-stepper" data-line-qty>' +
                '<button type="button" data-line-decrease aria-label="Decrease quantity">–</button>' +
                '<input type="text" value="' + item.quantity + '" readonly aria-label="Quantity">' +
                '<button type="button" data-line-increase aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<span class="price">' + formatMoney(item.final_line_price) + '</span>' +
            '</div>' +
            '<button type="button" class="cart-line__remove" data-line-remove>Remove</button>' +
          '</div>' +
        '</div>';
    }).join('');
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function refresh() {
    var version = ++refreshVersion;
    var request = fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('cart_refresh_failed');
        return res.json();
      })
      .then(function (cart) {
        if (version === refreshVersion) render(cart);
        return cart;
      })
      .catch(function () { return null; });
    refreshPromise = request;
    return request;
  }

  function changeLine(key, quantity) {
    if (isUpdating) return;
    isUpdating = true;
    if (itemsRoot) itemsRoot.setAttribute('aria-busy', 'true');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (res) {
      if (!res.ok) throw new Error('cart_change_failed');
      return res.json();
    }).then(render).catch(refresh).finally(function () {
      isUpdating = false;
      if (itemsRoot) itemsRoot.removeAttribute('aria-busy');
    });
  }

  if (itemsRoot) {
    itemsRoot.addEventListener('click', function (e) {
      var line = e.target.closest('[data-cart-line-key]');
      if (!line) return;
      var key = line.getAttribute('data-cart-line-key');
      var qtyInput = line.querySelector('[data-line-qty] input');
      var qty = parseInt(qtyInput.value, 10);

      if (e.target.closest('[data-line-increase]')) changeLine(key, qty + 1);
      if (e.target.closest('[data-line-decrease]')) changeLine(key, Math.max(0, qty - 1));
      if (e.target.closest('[data-line-remove]')) changeLine(key, 0);
    });
  }

  document.addEventListener('cart:refresh', refresh);
  refresh();
})();
